/* globals $, jQuery, ShopgateProductDetailsCore, */
(function ($) {
  let paymentButtonRequestRunning = false;
  // eslint-disable-next-line no-param-reassign
  $.fn.shopgatePaypalExpress = function (settings) {
    const defaults = {
      urlPaypalExpress: '',
    };

    const that = this;
    const $button = $(this);

    const options = $.extend(true, {}, defaults, settings);

    const clientIsApp = window.checkClientIsShopgateApp();

    function onClick() {
      if (paymentButtonRequestRunning) {
        return false;
      }

      paymentButtonRequestRunning = true;

      let source = $(this).data('source');
      const data = {};

      // legacy check for old payment buttons
      if ($(this).data('item-detail')) {
        source = 'product';
      }

      if (source === 'product' && ShopgateProductDetailsCore.getSelectedProduct()) {
        data.selectedValues = ShopgateProductDetailsCore.getSelectedValues(true);
      }

      $.shopgate.ajax({
        type: 'POST',
        url: options.urlPaypalExpress,
        dataType: 'json',
        addHistoryEntry: true,
        data,
        beforeSend() {
          $(document).trigger('shopgateFramework.waitingIndicator.show');
        },
        success(response) {
          if (typeof response === 'object') {
            // the server requested a redirect
            if (!response.redirect || (!response.redirect && !response.success)) {
              $(document).trigger('shopgateFramework.waitingIndicator.hide');
            }

            // If the PPE request was successful within the app, the response contains a success
            // property which value is TRUE. The mobile website behaves different, since the
            // redirect logic is located within the AppController. In case of a redirect, this
            // logic will break the current program and send a response object that just contains
            // a redirect property. So the success case has to be checked in two different ways
            if (
              window.SgTrackingCore &&
              ((clientIsApp && response.success === true) || (!clientIsApp && response.redirect))
            ) {
              const additionalData = {
                checkoutType: 'paypal_express',
              };

              if (data.selectedValues) {
                additionalData.quantity = data.selectedValues.quantity;
              }

              window.SgTrackingCore.track.initiatedCheckout(
                $.extend(true, {}, window.sgData, additionalData)
              );
            }
          }
        },
        complete() {
          paymentButtonRequestRunning = false;
        },
      });

      return true;
    }

    // Take care that the click listener is only added once to the payment button.
    // We had situations where the plugin was executed multiple times for the same button which
    // caused multiple identical requests for just one button click.
    // In combination with the paymentButtonRequestRunning variable
    // this situation shouldn't happen again :-P
    if (!$button.data('paymentPluginExecuted')) {
      $button.off('click.paypalExpressPaymentButton').on('click.paypalExpressPaymentButton', onClick).data('paymentPluginExecuted', true);
    }

    // register as product details plugin if available
    const ppeUI = function (productDetailsCore) {
      /**
       * Disable Paypal-Express-Button if product is not orderable
       * @param  {string} callType The type of the function call (products.ui or products.data)
       * @param  {Object} currentStates The current core states
       */
      function onUpdateStates(callType, currentStates) {
        if (callType && callType !== 'products.ui') {
          return;
        }

        if (typeof currentStates.cartButtonLocked !== 'undefined') {
          that.toggleClass('locked', currentStates.cartButtonLocked);
        }

        const disableCartButton = productDetailsCore.isAddToCartButtonDisabled();

        that.toggleClass('disabled', disableCartButton);
      }

      return {
        vendor: 'Shopgate',
        name: 'ShopgatePaypalExpress',
        type: ['products.ui'],
        onUpdateStates,
      };
    };

    if (
      typeof ShopgateProductDetailsCore === 'object' &&
      typeof ShopgateProductDetailsCore.registerPlugin === 'function'
    ) {
      ShopgateProductDetailsCore.registerPlugin(ppeUI);
    }
  };
}(jQuery));



// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-paypal-express.js